import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { addItem, removeItem } from "../utils/slice/cartSlice";

const ItemList = ({ items, showRemove = false }) => {
  const dispatch = useDispatch();
  const cartItems = useSelector((store) => store.cart.items);

  const addItemToCart = (item) => {
    dispatch(addItem(item));
  };

  const removeFromCart = (item) => {
    dispatch(removeItem(item.card.info.id));
  };

  const getItemQuantity = (itemId) => {
    const item = cartItems.find(
      (cartItem) => cartItem?.card?.info?.id === itemId
    );
    return item ? item.quantity || 1 : 0; // Default quantity to 1 if not set.
  };

  return (
    <div>
      {items.map((item) => {
        const itemId = item?.card?.info?.id;
        const quantity = getItemQuantity(itemId);

        return (
          <div
            key={itemId}
            className="border-b-2 border-slate-600 p-2 text-left m-2 flex justify-between "
          >
            <div className="w-9/12">
              <div className="py-2">
                <p className="text-decor font-semibold my-1">
                  {item?.card?.info?.name}
                </p>
                <p className="text-decor font-bold">
                  ₹{" "}
                  {item?.card?.info?.price / 100 ||
                    item?.card?.info?.defaultPrice / 100}
                </p>
              </div>
              <p className="text-decor text-xs text-gray-600 tracking-wide">
                {item?.card?.info?.description}
              </p>
            </div>
            <div className="w-3/12 p-4">
              {item?.card?.info?.imageId && (
                <img
                  src={`https://media-assets.swiggy.com/swiggy/image/upload/${item?.card?.info?.imageId}`}
                  className="w-full rounded-md"
                />
              )}
              <div className="flex items-center justify-center mt-2">
                {showRemove ? (
                  <button
                    className="text-decor text-white bg-slate-950 px-2 py-1 rounded"
                    onClick={() => removeFromCart(item)}
                  >
                    Remove
                  </button>
                ) : quantity === 0 ? (
                  <button
                    className="text-decor text-white bg-slate-950 px-4 py-2 rounded"
                    onClick={() => addItemToCart(item)}
                  >
                    Add +
                  </button>
                ) : (
                  <div className="flex items-center space-x-2">
                    <button
                      className="text-decor text-white bg-slate-950 px-3 py-1 rounded"
                      onClick={() => removeFromCart(item)}
                    >
                      -
                    </button>
                    <span className="text-decor font-bold">{quantity}</span>
                    <button
                      className="text-decor text-white bg-slate-950 px-3 py-1 rounded"
                      onClick={() => addItemToCart(item)}
                    >
                      +
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ItemList;
